export const GET_WORKFLOW = `
  query GetWorkflow($workflowId: String!) {
    workflow(id: $workflowId) {
      _id
      name
      servicesConfig
      steps {
        id
        schemaId
        next {
          nextStep
          conditionKey
          conditionValue
        }
      }
      workflowId
    }
  }
`;

export const GET_WORKFLOW_SCREEN = `
  query GetWorkflowScreen($screenId: String!) {
    findWorkflowScreenById(id: $screenId) {
      _id
      schema {
        widget
        title
        properties
        type
        required
      }
      fieldMapping
      fieldTemplate
      tabMapping
      tabWiseSaveMapping
    }
  }
`;
